const ADDRESS_LINE1 = 'ADDRESS_LINE1';
const ADDRESS_LINE2 = 'ADDRESS_LINE2';
const ADDRESS_LINE_OPTIONAL = 'ADDRESS_LINE_OPTIONAL';
const ALIEN_NUMBER = 'ALIEN_NUMBER';
const ALL_DIGITS = 'ALL_DIGITS';
const BIRTH_DATE = 'BIRTH_DATE';
const CERTIFICATE_NUMBER ='CERTIFICATE_NUMBER';
const CHECKED = 'CHECKED';
const CHOSEN = 'CHOSEN';
const CHOSEN_FROM_LIST = 'CHOSEN_FROM_LIST';
const CITY = 'CITY';
const CITY_OPTIONAL = 'CITY_OPTIONAL';
const DATE = 'DATE';
const DATE_BETWEEN_TWO_DATES = 'DATE_BETWEEN_TWO_DATES';
const DATE_OR_NULL = 'DATE_OR_NULL';
const DATE_OR_NULL_GREATER_THAN_START = 'DATE_OR_NULL_GREATER_THAN_START';
const DATE_GREATER_THAN_START = 'DATE_GREATER_THAN_START';
const DATE_NOT_GREATER_THAN_CURRENT = 'DATE_NOT_GREATER_THAN_CURRENT';
const DATE_PREGNANCY = 'DATE_PREGNANCY';
const DATE_VALID_CHIP_DENIAL_DATE = 'DATE_VALID_CHIP_DENIAL_DATE';
const DATEPICKER = 'DATEPICKER';
const DOCUMENT_DESCRIPTION = 'DOCUMENT_DESCRIPTION';
const EMAIL = 'EMAIL';
const EMPLOYER_NAME = 'EMPLOYER_NAME';
const HARDSHIP_EXEMPT_NUMBER_MAX_LENGTH = 20;
const HOME_ADDRESS_LINE1 = 'HOME_ADDRESS_LINE1';
const HOME_ADDRESS_LINE2 = 'HOME_ADDRESS_LINE2';
const IS_SIGNED = 'IS_SIGNED';
const I_551 = 'I_551';
const I_94 = 'I_94';
const LAST_N_DAYS = 'LAST_N_DAYS';
const LAST_24_MONTHS = 'LAST_24_MONTHS';
const LENGTH = 'LENGTH';
const MEDICARE_START_DATE = 'MEDICARE_START_DATE';
const MIDDLE_NAME = 'MIDDLE_NAME';
const MONEY ='MONEY';
const MONEY_NOT_EXCEED = 'MONEY_NOT_EXCEED';
const NAME = 'NAME';
const NATURALIZATION_NUMBER ='NATURALIZATION_NUMBER';
const NOT_EMPTY = 'NOT_EMPTY';
const NOT_UNSPECIFIED = 'NOT_UNSPECIFIED';
const ONLY_LETTERS_AND_SPL_CHARS = 'ONLY_LETTERS_AND_SPL_CHARS';
const OTHER_RACE_OR_ETHNICITY = 'OTHER_RACE_OR_ETHNICITY';
const PASSPORT = 'PASSPORT';
const PHONE_EXTENSION = 'PHONE_EXTENSION';
const PHONE_NUMBER = 'PHONE_NUMBER';
const PHONE_NUMBER_PROVIDED = 'PHONE_NUMBER_PROVIDED';
const RANGE = 'RANGE';
const REPRESENTATIVE_ORGANIZATION_ID = 'REPRESENTATIVE_ORGANIZATION_ID';
const REPRESENTATIVE_ORGANIZATION_NAME = 'REPRESENTATIVE_ORGANIZATION_NAME';
const SEVIS_ID = 'SEVIS_ID';
const SPECIFIED = 'SPECIFIED';
const SSN = 'SSN';
const SSN_SIMPLIFIED = 'SSN_SIMPLIFIED';
const TOBACCO_AGE_LIMIT = 21;
const UNIQUE = 'UNIQUE';
const VISA = 'VISA';
const ZIP_CODE = 'ZIP_CODE';
const ZIP_CODE_5_DIGITS = 'ZIP_CODE_5_DIGITS';
const ZIP_CODE_LENGTH = 5;
const ACCESSCODE_MAX_LENGTH = 10;
const SSN_LENGTH = 9;
const MONTH_AND_DAY_LENGTH = 2;
const YEAR_LENGTH = 4;

export const VALIDATION_TYPES = {

    ACCESSCODE_MAX_LENGTH,
    ADDRESS_LINE1,
    ADDRESS_LINE2,
    ADDRESS_LINE_OPTIONAL,
    ALIEN_NUMBER,
    ALL_DIGITS,
    BIRTH_DATE,
    CERTIFICATE_NUMBER,
    CHECKED,
    CHOSEN,
    CHOSEN_FROM_LIST,
    CITY,
    CITY_OPTIONAL,
    DATE,
    DATE_BETWEEN_TWO_DATES,
    DATE_OR_NULL,
    DATE_OR_NULL_GREATER_THAN_START,
    DATE_GREATER_THAN_START,
    DATE_NOT_GREATER_THAN_CURRENT,
    DATE_PREGNANCY,
    DATE_VALID_CHIP_DENIAL_DATE,
    DATEPICKER,
    DOCUMENT_DESCRIPTION,
    EMAIL,
    EMPLOYER_NAME,
    HARDSHIP_EXEMPT_NUMBER_MAX_LENGTH,
    HOME_ADDRESS_LINE1,
    HOME_ADDRESS_LINE2,
    IS_SIGNED,
    I_551,
    I_94,
    LAST_N_DAYS,
    LAST_24_MONTHS,
    LENGTH,
    MEDICARE_START_DATE,
    MIDDLE_NAME,
    MONEY,
    MONEY_NOT_EXCEED,
    NAME,
    NATURALIZATION_NUMBER,
    NOT_EMPTY,
    NOT_UNSPECIFIED,
    ONLY_LETTERS_AND_SPL_CHARS,
    OTHER_RACE_OR_ETHNICITY,
    PASSPORT,
    PHONE_EXTENSION,
    PHONE_NUMBER,
    PHONE_NUMBER_PROVIDED,
    RANGE,
    REPRESENTATIVE_ORGANIZATION_ID,
    REPRESENTATIVE_ORGANIZATION_NAME,
    SEVIS_ID,
    SPECIFIED,
    SSN,
    SSN_SIMPLIFIED,
    SSN_LENGTH,
    TOBACCO_AGE_LIMIT,
    UNIQUE,
    VISA,
    ZIP_CODE,
    ZIP_CODE_LENGTH,
    ZIP_CODE_5_DIGITS,
    MONTH_AND_DAY_LENGTH,
    YEAR_LENGTH
};